import { spacing } from '@ardoq/design-tokens';
import styled from 'styled-components';
import { SIDEBAR_MENU_MENU_SELECTOR } from './SidebarMenuMenu';

export const SidebarMenuBody = styled.div`
  flex-grow: 1;
  overflow: auto;

  & > ${SIDEBAR_MENU_MENU_SELECTOR} {
    margin: ${spacing.s16} ${spacing.s8};
  }
`;
